import { $tid } from '@provider-portal/common/utils/testIdConfig';
import { LanguageUtils } from '@provider-portal/common/utils/translations';
import { getAppLocale } from 'utils/translations';

import { ProviderPortalApp } from './src/ProviderPortalApp';

// Set as early as possible so the browser's translate heuristic sees the real
// app locale instead of the static "en" baked into the Lattice HTML template.
document.documentElement.lang = LanguageUtils.toRequestLocale(getAppLocale());

const app = new ProviderPortalApp();
app.setup();

window.$tid = $tid;
